import { Mount } from "../enums";

export interface MountDefinition {
  readonly public_id: Mount;
  readonly name: string;
  readonly description: string;
}

const mountCatalog = {
  [Mount.CANON_EF]: {
    public_id: Mount.CANON_EF,
    name: "Canon EF",
    description: "Reflex Canon Full Frame e APS-C",
  },
  [Mount.CANON_EF_S]: {
    public_id: Mount.CANON_EF_S,
    name: "Canon EF-S (APS-C)",
    description: "Refelx Canon APS-C",
  },
  [Mount.CANON_RF]: {
    public_id: Mount.CANON_RF,
    name: "Canon RF",
    description: "Mirrorless Canon Full Frame e APS-C (nuova generazione)",
  },
  [Mount.CANON_RF_S]: {
    public_id: Mount.CANON_RF_S,
    name: "Canon RF (APS-C)",
    description: "Mirrorless Canon APS-C (nuova generazione)",
  },
  [Mount.CANON_M]: {
    public_id: Mount.CANON_M,
    name: "Canon M",
    description: "Mirrorless Canon APS-C (vecchia generazione)",
  },
  [Mount.NIKON_F]: {
    public_id: Mount.NIKON_F,
    name: "Nikon F",
    description: "Reflex Nikon Full Frame e APS-C",
  },
  [Mount.NIKON_F_DX]: {
    public_id: Mount.NIKON_F_DX,
    name: "Nikon F DX (APS-C)",
    description: "Reflex Nikon APS-C",
  },
  [Mount.NIKON_Z]: {
    public_id: Mount.NIKON_Z,
    name: "Nikon Z",
    description: "Mirrorless Nikon Full Frame e APS-C",
  },
  [Mount.NIKON_Z_DX]: {
    public_id: Mount.NIKON_Z_DX,
    name: "Nikon Z DX (APS-C)",
    description: "Mirrorless Nikon APS-C",
  },
  [Mount.SONY_E]: {
    public_id: Mount.SONY_E,
    name: "Sony E",
    description: "Mirrorless Sony Full Frame e APS-C",
  },
  [Mount.SONY_E_APS_C]: {
    public_id: Mount.SONY_E_APS_C,
    name: "Sony E (APS-C)",
    description: "Mirrorless Sony APS-C",
  },
  [Mount.SONY_A]: {
    public_id: Mount.SONY_A,
    name: "Sony A",
    description: "Reflex Sony Full Frame e APS-C",
  },
  [Mount.SONY_A_APS_C]: {
    public_id: Mount.SONY_A_APS_C,
    name: "Sony A (APS-C)",
    description: "Reflex Sony APS-C",
  },
  [Mount.PENTAX_K]: {
    public_id: Mount.PENTAX_K,
    name: "Pentax K",
    description: "Reflex Pentax Full Frame e APS-C",
  },
  [Mount.PENTAX_K_APS_C]: {
    public_id: Mount.PENTAX_K_APS_C,
    name: "Pentax K (APS-C)",
    description: "Reflex Pentax APS-C",
  },
  [Mount.FUJIFILM_X]: {
    public_id: Mount.FUJIFILM_X,
    name: "Fujifilm X",
    description: "Mirrorless Fujifilm APS-C",
  },
  [Mount.FUJIFILM_G]: {
    public_id: Mount.FUJIFILM_G,
    name: "Fujifilm G",
    description: "Mirrorless Fujifilm Medio Formato",
  },
  [Mount.L_MOUNT]: {
    public_id: Mount.L_MOUNT,
    name: "L-Mount",
    description: "Mirrorless Panasonic, Leica e Sigma Full Frame e APS-C",
  },
  [Mount.L_MOUNT_APS_C]: {
    public_id: Mount.L_MOUNT_APS_C,
    name: "L-Mount (APS-C)",
    description: "Mirrorless Leica APS-C",
  },
  [Mount.MICRO_FOUR_THIRDS]: {
    public_id: Mount.MICRO_FOUR_THIRDS,
    name: "Micro 4/3",
    description: "Mirrorless Panasonic e Olympus con sensore Micro 4/3",
  },
} as const satisfies Record<Mount, MountDefinition>;

export const MOUNT_CATALOG: Readonly<Record<Mount, MountDefinition>> =
  Object.freeze(mountCatalog);

export const MOUNTS: readonly MountDefinition[] =
  Object.freeze(Object.values(MOUNT_CATALOG));

const mountIds = new Set<string>(Object.values(Mount));

export const isMount = (value: unknown): value is Mount =>
  typeof value === "string" && mountIds.has(value);

export const getMountDefinition = (
  mount: Mount | string | null | undefined,
): MountDefinition | undefined =>
  isMount(mount) ? MOUNT_CATALOG[mount] : undefined;
